module.exports = __webpack_public_path__ + "static/images/suv.2j0vbsQ.svg";